import { components, type ClearIndicatorProps } from 'react-select';
import { m } from 'motion/react';
import { X } from 'lucide-react';
import type { TOption } from '../types';

export const CustomClearIndicator = (props: ClearIndicatorProps<TOption>) => {
  return (
    <components.ClearIndicator {...props} className="group">
      <m.div className="transition-colors duration-150 text-foreground/50 group-hover:text-action">
        <X className="w-4 h-4" />
      </m.div>
    </components.ClearIndicator>
  );
};
